




















































































































































































































































































































































































































import { getContentArea } from '@/contentful';
import moment from 'moment';
import { requiredIf } from 'vuelidate/lib/validators';
import {
  dialogMaxWidth,
  dateFormat,
  datePickerFormat,
  dateFormatYYYYMMDD,
  dateTransactionFormat,
} from '@/constants';
import { date, dateHelpers } from '@/validations';
import { PageSidebar } from '@/components/page-components';
import { AccountExportTools } from '@/components/account-components';
import { DatePicker } from '@/components/form-components';
import { DateFormat, FormValidation } from '@/mixins';
import store from '@/store';
import { LoadingService, ExtendMixins } from '@/services';
import { EventBus } from '@/event-bus';
import { taxDocs } from '@/api';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import {
  TaxFormSettings,
  AccountStatementInformation,
  AccountStatementSummaryRow,
  MemberAccountResponseModel,
  SelectOption,
  ErrorModelDisplay,
  AccountStatementsResponseModel,
  AccountStatementDetail,
  AccountStatementSelectedRange,
} from '@/@types/member';
import { isNil } from 'lodash';
import { StatementPDF } from '@/mixins/pdf-mixins';
import { StatementXLS } from '@/mixins/xls-mixins';

interface Data {
  taxYearsLoaded: boolean;
  hideRunoutAndDeadline: boolean;
  reportPeriod: string;
  taxYear: number;
  reportStartDate: string;
  reportEndDate: string;
  defaultReportEndDate: string;
  reportAsOfDate: string;
  selectedMonthEnding: moment.Moment | null;
  isLoading: boolean;
  sidebarHeading: string;
  sidebarContent: string;
  currentSettings: TaxFormSettings;
  errorDownloading: boolean;
  headers: any;
  selectedTransactionType: SelectOption;
  showErrorModel: ErrorModelDisplay;
  APIDateFormat: string;
}

export default ExtendMixins(
  DateFormat,
  FormValidation,
  StatementPDF,
  StatementXLS,
).extend({
  name: 'Statements',
  data(): Data {
    return {
      taxYearsLoaded: false,
      hideRunoutAndDeadline: true,
      reportPeriod: '',
      taxYear: moment().year(),
      reportStartDate: '',
      reportEndDate: '',
      defaultReportEndDate: '',
      reportAsOfDate: '',
      selectedMonthEnding: null,
      isLoading: false,
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      currentSettings: null,
      errorDownloading: false,
      // THIS IS A BANDAID FOR VUEITFY UNTIL COLSPAN CAN BE SET MANUALLY
      headers: [{}, {}, {}, {}],
      selectedTransactionType: { text: 'All', value: 'All' },
      showErrorModel: {
        reportStartDate: false,
        reportEndDate: false,
        reportAsOfDate: false,
      },
      APIDateFormat: dateFormatYYYYMMDD,
    };
  },
  beforeRouteEnter(to, from, next) {
    const isHSA =
      store.getters.currentAccount(to.params.id).productType === 'HSA';
    const promises = [getContentArea('statements-sidebar-content')];

    LoadingService.watchPromises(promises)
      .then((data) => {
        const SIDEBAR = data[0];
        if (SIDEBAR && SIDEBAR.fields) {
          to.meta.sidebarHeading = SIDEBAR.fields.headline;
          to.meta.sidebarContent = SIDEBAR.fields.content;
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  beforeMount() {
    this.showErrorModel = {
      reportStartDate: false,
      reportEndDate: false,
      reportAsOfDate: false,
    };

    this.setDefaultReportDates();
    this.getReport(true);
  },
  validations: {
    reportStartDate: {
      required: requiredIf((vm: any): boolean => {
        return vm.reportPeriod === 'date-range';
      }),
      date,
      afterAccountStartDate(value): boolean {
        return dateHelpers.sameOrAfterDate(this.account.startDate)(value);
      },
      beforeReportEndDate(value): boolean {
        return dateHelpers.sameOrBeforeDate(this.reportEndDate)(value);
      },
    },
    reportEndDate: {
      required: requiredIf((vm: any): boolean => {
        return vm.reportPeriod === 'date-range';
      }),
      date,
      beforeAccountEndDate(value): boolean {
        return dateHelpers.sameOrBeforeDate(this.account.endDate, dateFormat)(
          value,
        );
      },
      afterReportStartDate(value): boolean {
        return dateHelpers.sameOrAfterDate(this.reportStartDate)(value);
      },
    },
    reportAsOfDate: {
      required: requiredIf((vm: any): boolean => {
        return !vm.isHSAAccount && !vm.isVEBAAccount;
      }),
      date,
      afterAccountStartDate(value): boolean {
        return dateHelpers.sameOrAfterDate(this.account.startDate, dateFormat)(
          value,
        );
      },
    },
  },
  computed: {
    // TODO should import/create date formatting mixin like group/core
    dateTransactionFormat(): string {
      return dateTransactionFormat;
    },
    dateFormat(): string {
      return dateFormat;
    },
    dialogMaxWidth(): string {
      return dialogMaxWidth;
    },
    isHSA(): boolean {
      return (
        this.$store.getters.currentAccount(this.$route.params.id)
          .productType === 'HSA'
      );
    },
    accountInformation(): AccountStatementInformation[] {
      const info: AccountStatementInformation[] = [];
      if (this.memberAccountStatements.startDate) {
        info.push({
          label: 'statements_label_start-date',
          value: moment(this.memberAccountStatements.startDate).format(dateFormat),
        });
      }
      if (this.memberAccountStatements.endDate) {
        info.push({
          label: 'statements_label_end-date',
          value: moment(this.memberAccountStatements.endDate).format(dateFormat),
        });
      }
      if (this.memberAccountStatements.planType) {
        info.push({
          label: 'statements_label_current-plan-type',
          value: this.memberAccountStatements.planType,
        });
      }
      return info;
    },
    showReportInformation(): boolean | string {
      return (
        this.memberAccountStatements.termDate ||
        this.memberAccountStatements.graceEndDate ||
        (this.hideRunoutAndDeadline !== true &&
          this.memberAccountStatements.claimFilingDeadline &&
          this.memberAccountStatements.runoutPeriod == null) ||
        (this.hideRunoutAndDeadline !== true &&
          this.memberAccountStatements.runoutPeriod &&
          this.memberAccountStatements.runoutPeriod != null &&
          this.account.productType !== 'HSA')
      );
    },
    availableBalanceLabel(): string {
      if (this.memberAccountStatements.beginingBalance != null) {
        return 'statements_label_available-base-balance';
      }
      if (
        this.account.productType === 'HSA' &&
        this.reportPeriod === 'tax-year'
      ) {
        return 'statements_label_ending-balance';
      }
      return 'statements_label_available-balance';
    },
    statementSummaryRows(): AccountStatementSummaryRow[] {
      const POSSIBLE_SUMMARY_ROWS: AccountStatementSummaryRow[] = [
        {
          key: 'threshold',
          label: 'statements_label_threshold',
          value: this.memberAccountStatements.threshold,
        },
        {
          key: 'accumulation',
          label: 'statements_label_accumulation',
          value: this.memberAccountStatements.accumulation,
        },
        {
          key: 'beginingBalance',
          label: 'statements_label_beginning-balance',
          labelVar: {
            effectiveDate: moment(this.memberAccountStatements.reportStartDate).format(dateFormat),
          },
          value: this.memberAccountStatements.beginingBalance,
        },
        {
          key: 'rollover',
          label: 'statements_label_rollover',
          value: this.memberAccountStatements.rollover,
        },
        {
          key: 'currentTaxYearContributions',
          label: 'statements_label_contributions-current-tax-year',
          value: this.memberAccountStatements.currentTaxYearContributions,
        },
        {
          key: 'priorTaxYearContributions',
          label: 'statements_label_contributions-prior-tax-year',
          value: this.memberAccountStatements.priorTaxYearContributions,
        },
        {
          key: 'election',
          label: 'statements_label_election-amount',
          value: this.memberAccountStatements.election,
        },
        {
          key: 'employerFunding',
          label: 'statements_label_employer-function',
          value: this.memberAccountStatements.employerFunding,
        },
        {
          key: 'contributions',
          label: 'statements_label_contributions',
          value: this.memberAccountStatements.contributions,
        },
        {
          key: 'otherTransfers',
          label: 'statements_label_other-transfers',
          value: this.memberAccountStatements.otherTransfers,
        },
        {
          key: 'investmentTransfer',
          label: 'statements_label_investment-transfers',
          value: this.memberAccountStatements.investmentTransfer,
        },
        {
          key: 'interest',
          label: 'statements_label_interest-earned',
          value: this.memberAccountStatements.interest,
        },
        {
          key: 'claims',
          label: 'statements_label_withdrawls',
          value: this.memberAccountStatements.claims,
        },
        {
          key: 'fees',
          label: 'statements_label_fees',
          value: this.memberAccountStatements.fees,
        },
        {
          key: 'availableBalanceLabel',
          label: this.availableBalanceLabel,
          value:
            this.memberAccountStatements.availableBalance >= 9999999.99
              ? this.$options.filters.t('statements_label_n/a')
              : this.memberAccountStatements.availableBalance,
        },
      ];
      return POSSIBLE_SUMMARY_ROWS.filter((summaryRow) => {
        let isValidRecord = false;
        /* MBR-022 - BR-1.36 – When creating the account balance grid per BR-1.34,
          the System will remove all rows where the data tag for that row is null. */
        if (
          summaryRow.value !== null &&
          typeof summaryRow.value !== 'undefined'
        ) {
          isValidRecord = true;
          if (
            summaryRow.value.hasOwnProperty('amount') &&
            (summaryRow.value.amount === null ||
              typeof summaryRow.value.amount === 'undefined')
          ) {
            isValidRecord = false;
          }
        }
        return isValidRecord;
      }).map((summaryRow) => {
        const VALUE = summaryRow.value.hasOwnProperty('amount')
          ? summaryRow.value.amount
          : summaryRow.value;
        return Object.assign(summaryRow, {
          value: VALUE,
        });
      });
    },
    allTransactions(): AccountStatementDetail[] {
      const allTransactions = [];
      const STATEMENTS = this.memberAccountStatements;
      const KEYS = Object.keys(STATEMENTS);
      KEYS.forEach((key) => {
        const STATEMENT_VALUE = STATEMENTS[key];
        if (STATEMENT_VALUE && STATEMENT_VALUE.details) {
          const STATEMENT_DETAILS =
            key === 'claims'
              ? STATEMENT_VALUE.details.map((transaction) => {
                return Object.assign(transaction, {
                  hasDetails: true,
                  hasDenial:
                    (transaction.deniedAmount &&
                      transaction.deniedAmount !== '') ||
                    (transaction.denialReason &&
                      transaction.denialReason !== ''),
                });
              })
              : STATEMENT_VALUE.details;

          const STATEMENT_DETAILS_CATEGORIZED = STATEMENT_DETAILS.map(
            (transaction) => {
              return Object.assign(transaction, {
                category: key,
              });
            },
          );
          allTransactions.push(...STATEMENT_DETAILS_CATEGORIZED);
        }
      });
      return allTransactions.map((transaction, index) => {
        return Object.assign(transaction, {index});
      });
    },
    statementTransactions(): AccountStatementDetail[] {
      return this.allTransactions.filter((transaction) => {
        return (
          this.selectedTransactionType.value === 'All' ||
          // @ts-ignore need to update how we handled option fields
          transaction.category === this.selectedTransactionType.value
        );
      });
    },
    computedTransactionTypes(): SelectOption[] {
      // Returns a unique array of all the transaction types
      // TODO implement correct "All" value handling for types
      return [
        {
          text: 'All',
          value: 'All',
        },
        ...(
          this.statementSummaryRows
            .filter(
              (statementTransaction) =>
                this.memberAccountStatements[statementTransaction.key] &&
                this.memberAccountStatements[statementTransaction.key].details,
            )
            .map((statementTransaction) => {
              return {
                text: this.$options.filters.t(statementTransaction.label),
                value: statementTransaction.key,
              };
            })
        ),
      ];
    },
    sortedStatementTransactions(): AccountStatementDetail[] {
      return this.statementTransactions.sort((a, b) => {
        // Sort by posted date
        if (
          moment(a.postedDate, dateFormatYYYYMMDD).isBefore(
            moment(b.postedDate, dateFormatYYYYMMDD),
          )
        ) {
          return 1;
        } else if (
          moment(b.postedDate, dateFormatYYYYMMDD).isBefore(
            moment(a.postedDate, dateFormatYYYYMMDD),
          )
        ) {
          return -1;
        }

        // Sort by tax year
        if (a.taxYear < b.taxYear) {
          return 1;
        } else if (a.taxYear > b.taxYear) {
          return -1;
        }

        // Sort by transaction
        if (a.transactions < b.transactions) {
          return 1;
        } else if (a.transactions > b.transactions) {
          return -1;
        }

        // Sort by amount
        if (a.amount < b.amount) {
          return 1;
        } else if (a.amount > b.amount) {
          return -1;
        }

        return 0;
      });
    },
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
    accountStartDate(): string {
      return moment(this.account.startDate, dateFormat).format(dateFormat);
    },
    isHSAAccount(): boolean {
      return this.account.productType === 'HSA';
    },
    isVEBAAccount(): boolean {
      return this.account.productType === 'VEBA';
    },
    reportPeriodOptions(): SelectOption[] {
      let options: SelectOption[] = [];
      if (this.isHSAAccount) {
        this.reportPeriod = 'monthly-statement';
        options = [
          {
            value: 'monthly-statement',
            text: this.$options.filters.t('statements_label_monthly-statement'),
          },
          {
            value: 'tax-year',
            text: this.$options.filters.t('statements_label_tax-year'),
          },
          {
            value: 'date-range',
            text: this.$options.filters.t('statements_label_date-range'),
          },
        ];
      } else if (this.isVEBAAccount) {
        this.reportPeriod = 'monthly-statement';
        options = [
          {
            value: 'monthly-statement',
            text: this.$options.filters.t('statements_label_monthly-statement'),
          },
          {
            value: 'date-range',
            text: this.$options.filters.t('statements_label_date-range'),
          },
        ];
      }

      return options;
    },
    monthEndingOptions(): SelectOption[] {
      /* MBR-022 - BR-1.05 – the Month Ending dropdown will contain up to 12 values. The
        System will default the initial Month Ending value to the last day of the prior month.
        The System will also include the 11 month ends prior to the initial Month Ending value.
        The dropdown values will be sorted in descending order.If the current date is the 1st
        of the month, the System will set the initial Month Ending value to the last day of the
        month prior to the prior month end (the prior month cannot be included until after interest
        has been run, which is expected to complete on the 1stof the month for the prior month). */
      const options: SelectOption[] = [];
      for (let i = 1; i <= 12; i++) {
        const endOfMonth = moment()
          .subtract(i, 'months')
          .endOf('month');
        const startDate = moment(this.account.startDate, dateFormat);
        if (endOfMonth.isAfter(startDate)) {
          options.push({
            value: endOfMonth,
            text: endOfMonth.format(dateFormat),
          });
        }
      }
      return options;
    },
    monthEnding: {
      get(): SelectOption | null {
        if (this.monthEndingOptions.length > 0) {
          return this.monthEndingOptions[0];
        }
        return null;
      },
      set(val): void {
        this.selectedMonthEnding = val;
      },
    },
    taxYearOptions(): SelectOption[] {
      const options: SelectOption[] = [];
      let thisYear = moment().year();
      const startYear = moment(this.account.startDate, dateFormat).year();
      const endYear = moment(this.account.endDate, dateFormat).year();

      if (moment(thisYear, 'YYYY').isAfter(endYear)) {
        thisYear = endYear;
      }

      for (let i = 0; i <= thisYear - startYear; i++) {
        options.push({
          value: thisYear - i,
          text: (thisYear - i).toString(),
        });
      }
      return options;
    },
    memberAccountStatements(): AccountStatementsResponseModel {
      // TODO should modify field retrievals to check and see if account statement retrieved
      return this.$store.getters.memberAccountStatements ? this.$store.getters.memberAccountStatements : {};
    },
    memberId(): string {
      return this.$store.getters.user.memberId;
    },
    accountKey(): string {
      return this.$route.params.id;
    },
    documentExportName(): string {
      return 'statement';
    },

    // VALIDATIONS
    reportStartDateErrors(): string[] {
      const formField = 'reportStartDate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-statements_form-error_report-start-date_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-statements_form-error_report-start-date_invalid-format',
            'global_form-error_date_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-statements_form-error_report-start-date_after-account-start-date',
          'afterAccountStartDate',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-statements_form-error_report-start-date_invalid',
          'beforeReportEndDate',
        ),
      ]);
    },
    reportEndDateErrors(): string[] {
      const formField = 'reportEndDate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-statements_form-error_report-end-date_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-statements_form-error_report-end-date_invalid-format',
            'global_form-error_date_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-statements_form-error_report-end-date_after-account-end-date',
          'beforeAccountEndDate',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-statements_form-error_report-end-date_invalid',
          'afterReportStartDate',
        ),
      ]);
    },
    reportAsOfDateErrors(): string[] {
      const formField = 'reportAsOfDate';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-statements_form-error_report-as-of-date_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'account-statements_form-error_report-as-of-date_invalid-format',
            'global_form-error_date_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'account-statements_form-error_report-as-of-date_after-account-start-date',
          'afterAccountStartDate',
        ),
      ]);
    },
    selectedRange(): AccountStatementSelectedRange {
      let payload = {
        startDate: null,
        endDate: null,
        taxYear: null,
      };
      if (this.isHSAAccount || this.isVEBAAccount) {
        if (this.reportPeriod === 'monthly-statement') {
          const monthEnding = this.selectedMonthEnding
            ? this.selectedMonthEnding.format(dateFormatYYYYMMDD)
            : this.monthEnding.value.format(dateFormatYYYYMMDD);

          payload = {
            startDate: moment(monthEnding, dateFormatYYYYMMDD)
              .date(1)
              .format(dateFormatYYYYMMDD),
            endDate: monthEnding,
            taxYear: null,
          };
        } else if (this.reportPeriod === 'tax-year') {
          payload = {
            startDate: null,
            endDate: null,
            taxYear: this.taxYear,
          };
        } else if (this.reportPeriod === 'date-range') {
          payload = {
            startDate: moment(this.reportStartDate, dateFormat).format(
              dateFormatYYYYMMDD,
            ),
            endDate: moment(this.reportEndDate, dateFormat).format(dateFormatYYYYMMDD),
            taxYear: null,
          };
        }
      } else {
        payload = {
          startDate: moment(this.account.startDate, dateFormat).format(dateFormatYYYYMMDD),
          endDate: moment(this.reportAsOfDate, dateFormat).format(dateFormatYYYYMMDD),
          taxYear: null,
        };
      }

      return payload;
    },
    documentServiceQueryParams(): string {
      const payload = this.selectedRange;
      if (payload.startDate && payload.endDate) {
        let params = '?startDate=' + payload.startDate;
        params += '&endDate=' + payload.endDate;
        return params;
      }
      return '?taxYear=' + payload.taxYear;
    },
  },
  methods: {
    getCategoryString(transaction): string {
      if (this.isRolledForwardTransaction(transaction)) {
        return transaction.transactions;
      }
      const CATEGORY = this.statementSummaryRows.find((category) => {
        return category.key === transaction.category;
      });

      return CATEGORY.label;
    },
    isRolledForwardTransaction(transaction): boolean {
      return transaction.category === 'claims' && !transaction.postedDate;
    },
    setDefaultReportDates(): void {
      this.reportStartDate = moment()
        .startOf('year')
        .isSameOrAfter(moment(this.account.startDate, dateFormat))
        ? moment()
          .startOf('year')
          .format(dateFormat)
        : this.account.startDate;
      this.defaultReportEndDate = moment()
        .subtract(1, 'day')
        .isSameOrBefore(moment(this.account.endDate, dateFormat))
        ? moment()
          .subtract(1, 'day')
          .format(dateFormat)
        : this.account.endDate;
      this.reportEndDate = moment(
        this.defaultReportEndDate,
        dateFormat,
      ).isBefore(moment(this.reportStartDate, dateFormat))
        ? this.reportStartDate
        : this.defaultReportEndDate;

      if (
        moment()
          .subtract(1, 'month')
          .endOf('month')
          .isSameOrAfter(moment(this.account.startDate, dateFormat))
      ) {
        if (
          moment()
            .subtract(1, 'month')
            .endOf('month')
            .isSameOrAfter(moment(this.account.endDate, dateFormat))
        ) {
          this.reportAsOfDate = this.account.endDate;
        } else {
          this.reportAsOfDate = moment()
            .subtract(1, 'month')
            .endOf('month')
            .format(dateFormat);
        }
      } else {
        this.reportAsOfDate = this.account.startDate;
      }
    },
    deconstructReportStartDate(): void {
      this.reportStartDate = InputMaskTypes.date.deconstruct(
        this.reportStartDate,
      );
      this.getReport(
        !this.$v.reportStartDate.$invalid && !this.$v.reportEndDate.$invalid,
      );
    },
    deconstructReportEndDate(): void {
      this.reportEndDate = InputMaskTypes.date.deconstruct(this.reportEndDate);
      this.getReport(
        !this.$v.reportStartDate.$invalid && !this.$v.reportEndDate.$invalid,
      );
    },
    deconstructReportAsOfDate(): void {
      this.reportAsOfDate = InputMaskTypes.date.deconstruct(
        this.reportAsOfDate,
      );
      this.getReport(!this.$v.reportAsOfDate.$invalid);
    },
    updateReport(): void {
      setTimeout(() => {
        this.selectedTransactionType = { text: 'All', value: 'All' };
        this.getReport(true);
      }, 0);
    },
    updatePeriod(): void {
      this.selectedMonthEnding = this.monthEnding.value;
      this.updateReport();
    },
    downloadForm(settings): void {
      settings.loading = true;
      taxDocs
        .get(settings.route(), {responseType: 'blob'})
        .then((response) => {
          const link = document.createElement('a');

          // Edge
          if (window.Navigator.msSaveOrOpenBlob) {
            const newBlob = new Blob(response.data);
            window.Navigator.msSaveOrOpenBlob(
              newBlob,
              settings.filename() + settings.extension,
            );
          } else if (window.navigator.msSaveOrOpenBlob) {
            // IE11
            const newBlob = new Blob([response.data], {
              type: response['content-type'],
            });
            window.navigator.msSaveOrOpenBlob(
              newBlob,
              settings.filename() + settings.extension,
            );
          } else {
            // Everything else
            link.href = window.URL.createObjectURL(response.data);
          }

          link.download = settings.filename();
          document.body.appendChild(link);
          link.click();
          link.remove();
          settings.loading = false;
        })
        .catch(() => {
          settings.loading = false;
          this.currentSettings = settings;
          this.errorDownloading = true;
        });
    },
    tryFormDownloadAgain(): void {
      this.errorDownloading = false;
      this.downloadForm(this.currentSettings);
    },
    dismissFormDownloadError(): void {
      this.errorDownloading = false;
    },
    updateReportStartDate(startDate): void {
      this.reportStartDate = this.DateFormatMixin.formatDate(startDate);
      this.FormValidationMixin.triggerBlur('reportStartDate');
      this.FormValidationMixin.updateHasChanged();
      this.getReport(
        !this.$v.reportStartDate.$invalid && !this.$v.reportEndDate.$invalid,
      );
    },
    updateReportEndDate(endDate): void {
      this.reportEndDate = this.DateFormatMixin.formatDate(endDate);
      this.FormValidationMixin.triggerBlur('reportEndDate');
      this.FormValidationMixin.updateHasChanged();
      this.getReport(
        !this.$v.reportStartDate.$invalid && !this.$v.reportEndDate.$invalid,
      );
    },
    updateReportAsOfDate(asOfDate): void {
      this.reportAsOfDate = this.DateFormatMixin.formatDate(asOfDate);
      this.FormValidationMixin.triggerBlur('reportAsOfDate');
      this.FormValidationMixin.updateHasChanged();
      this.getReport(!this.$v.reportAsOfDate.$invalid);
    },
    allowedReportStartDates(startDate): boolean {
      const testBeforeEndDate = !this.$v.reportEndDate.$invalid;
      if (!testBeforeEndDate) {
        return moment(startDate, datePickerFormat).isSameOrAfter(
          moment(this.account.startDate, dateFormat),
          'day',
        );
      }
      return (
        moment(startDate, datePickerFormat).isSameOrAfter(
          moment(this.account.startDate, dateFormat),
          'day',
        ) &&
        moment(startDate, datePickerFormat).isSameOrBefore(
          moment(this.reportEndDate, dateFormat),
          'day',
        )
      );
    },
    allowedReportEndDates(endDate): boolean {
      const testAfterStartDate = !this.$v.reportStartDate.$invalid;
      if (!testAfterStartDate) {
        return moment(endDate, datePickerFormat).isSameOrAfter(
          moment(this.account.startDate, dateFormat),
          'day',
        );
      }
      return (
        moment(endDate, datePickerFormat).isSameOrAfter(
          moment(this.reportStartDate, dateFormat),
          'day',
        ) &&
        moment(endDate, datePickerFormat).isSameOrAfter(
          moment(this.account.startDate, dateFormat),
          'day',
        )
      );
    },
    allowedReportAsOfDates(reportDate): boolean {
      const minDate = moment(this.account.startDate, dateFormat);
      const maxDate = moment(this.account.endDate, dateFormat);
      return (
        moment(reportDate, datePickerFormat).isSameOrAfter(minDate) &&
        moment(reportDate, datePickerFormat).isSameOrBefore(maxDate)
      );
    },
    getReport(okToTrigger = false): void {
      if (okToTrigger) {
        setTimeout(() => {
          this.isLoading = true;
          const payload = this.selectedRange;

          this.$store
            .dispatch('getMemberAccountStatement', {
              accountId: this.$route.params.id,
              payload,
            })
            .then(() => {
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
              EventBus.$emit('openModal', 'Error', {
                message: 'global_connection-error',
              });
            });
        }, 0);
      }
    },
  },
  components: {
    PageSidebar,
    AccountExportTools,
    DatePicker,
  },
});
